import { QueryClient } from '@tanstack/react-query'
import { DEFAULT_STALE_TIME, DEFAULT_GC_TIME } from './queryConfig'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: DEFAULT_STALE_TIME,
      gcTime: DEFAULT_GC_TIME,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})
